if (!customElements.get('number-component')) {
  const numberElement = class extends HTMLElement {
    constructor() {
      super();
      this.value = parseFloat(this.dataset.value);

      if (isNaN(this.value)) {
        this.value = 0;
      }

      this.content = this.lastElementChild || this;
    }

    connectedCallback() {
      this.set(this.value);
    }

    get() {
      return this.value;
    }

    set(value) {
      this.value = parseFloat(value);

      if (isNaN(this.value)) {
        this.value = 0;
      }

      this.content.innerHTML = this.formatNumber(this.value);
    }

    formatNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  };

  customElements.define('number-component', numberElement);
}
